import React from "react";

import CategorieJudoka from "../CategorieJudoka";

function JudokaCategoryCard({ judoka }) {
  const categoryReady = Boolean(judoka?.genre && judoka?.date_naissance);

  return (
    <div className="p-5 sm:p-6">
      <div className="rounded-[1.5rem] border border-slate-200 bg-slate-50 p-4 dark:border-white/10 dark:bg-white/[0.05]">
        <p className="text-xs font-bold uppercase tracking-[0.16em] text-slate-400">
          Catégorie sportive
        </p>

        {categoryReady ? (
          <div className="mt-4">
            <CategorieJudoka
              key={`${judoka.id}-${judoka.genre}-${judoka.date_naissance}-${judoka.poids}`}
              genre={judoka.genre}
              date_naissance={judoka.date_naissance}
              poids={judoka.poids}
            />
          </div>
        ) : (
          <p className="mt-3 text-sm font-medium leading-6 text-slate-500 dark:text-white/50">
            Renseignez le genre, la date de naissance et le poids pour calculer
            la catégorie.
          </p>
        )}
      </div>
    </div>
  );
}

export default JudokaCategoryCard;